// $('.single-item').slick();
$('.one-time').slick({
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  adaptiveHeight: true,
});
